import React from 'react';
import {DmsTab} from 'Components';
import {hashHistory} from 'react-router';
import {Form, Input, Select, Button, Row, Col, Upload, TreeSelect, message} from 'antd';
import {categoryAdd, categoryModify, categoryDetail, categoryTree} from '../../service/category';
import {config} from 'Utils';
import {nameValidator, checkCode} from '../../utils/regexp.js';
import {showSpin, hideSpin} from 'Utils';
const Option = Select.Option;
const FormItem = Form.Item;
const {TextArea} = Input;


class Categoryadd extends React.Component {
	constructor(props) {
		super(props);
		this.id = props.location.query.editindex === '0' ? 0 : props.location.query.editindex;
		this.state = {
			opts: ['新建分类'],
			detail: {},
			parent: {},
			fileList: [],
			tree: [],
			parentFlag: false
		};
		this.getCategory = this.getCategory.bind(this);
	}

	componentDidMount() {
		this.getCategory();
		if (this.props.location.query.editindex) {
			this.setState({
				opts: ['编辑分类']
			})
			//根据传过来的editindex，获取特定的值，并赋值给detail
			var editObj = {};
			editObj.id = parseInt(this.props.location.query.editindex, 0);
			categoryDetail(editObj).then(result => {
				var fileArr = this.state.fileList;
				if (result.status) {
					if (result.data.dmsCommonAttachFile != null) {
						var fileObj = {};
						fileObj.uid = -1;
						fileObj.name = result.data.dmsCommonAttachFile.fileName;
						fileObj.url = `${config.server}${result.data.dmsCommonAttachFile.filePath}`;
						fileObj.thumbUrl = `${config.server}${result.data.dmsCommonAttachFile.filePath}`;
						fileArr.push(fileObj);
					}
					result.data.fullPath = result.data.fullPath ? result.data.fullPath.replace(/\./g, ',') : '';
					result.data.path = result.data.path ? result.data.path.replace(/\./g, ',') : '';
					if (result.data.fullPath) {
						if (result.data.fullPath.indexOf(',') == -1) {
							result.data.parentIdText = '';
						} else {
							var pathArr = result.data.fullPath.split(',');
							result.data.parentIdText = pathArr[pathArr.length - 2];
						}
					}
					result.data.parentId = result.data.parentId ? `${result.data.parentId}` : '';
					this.setState({
						detail: result.data,
						fileList: fileArr
					})
				} else {
					message.error(result.message);
				}
			})
		}

		if (this.props.location.query.addindex) {
			this.setState({
				opts: ['增加子类'],
			})
			//根据传过来的addindex，获取特定的值，并赋值给parent

			var childrenObj = {};
			childrenObj.id = parseInt(this.props.location.query.addindex, 0);
			categoryDetail(childrenObj).then(result => {
				if (result.status) {
					this.setState({
						parentFlag: true,
						parent: result.data,
						detail: {...this.state.detail, parentIdText: result.data.name}
					})
				} else {
					message.error(result.message);
				}
			})
		}
	}

	//获取分类
	getCategory() {
		categoryTree({id: 1}).then(result => {
			if (result.status) {
				this.setState({
					tree: result.data
				})
			} else {
				message.error(result.message);
			}
		})
	}


	//取消按钮
	cancelHandle() {
		hashHistory.goBack();
	}

	//提交按钮
	submitHandle() {
		const {validateFields, getFieldsValue} = this.props.form;

		validateFields((errors) => {//表单校验
			if (errors) {
				return
			}//表单校验有误，则不执行下面的代码
			const data = {
				...getFieldsValue() //获取用户输入
			};

      showSpin();
			//编辑
			if (this.props.location.query.editindex) {
				if (this.state.fileList[0] != null && this.state.fileList[0].response) {
					data.attachId = this.state.fileList[0].response.data.id;
				} else {
					data.attachId = this.state.detail.attachId;
				}
				if (data.parentId !== undefined) {
					if (parseInt(data.parentId, 0)) {
						if (parseInt(data.parentId, 0) === this.state.detail.id) {
							data.parentId = this.state.detail.parentId;
						} else {
							data.parentId = parseInt(data.parentId, 0);
						}
					} else {
						data.parentId = this.state.detail.parentId;
					}
				} else {
					data.parentId = 0;
				}
				data.id = this.state.detail.id;
				categoryModify(data).then(result => {
					hideSpin();
					if (result.status) {
						message.success(result.message);
						hashHistory.goBack();
					} else {
						message.error(result.message);
					}
				})
			} else if (this.props.location.query.addindex) {
				//增加子类
				data.parentId = parseInt(this.props.location.query.addindex, 0);
				if (this.state.fileList[0] != null && this.state.fileList[0].response) {
					data.attachId = this.state.fileList[0].response.data.id;
				} else {
					data.attachId = null;
				}
				categoryAdd(data).then(result => {
					hideSpin();
					if (result.status) {
						message.success(result.message);
						hashHistory.goBack();
					} else {
						message.error(result.message);
					}
				})
			} else {
				//新建分类
				if (parseInt(data.parentId, 0)) {
					if (this.state.fileList[0] != null && this.state.fileList[0].response) {
						data.attachId = this.state.fileList[0].response.data.id;
					} else {
						data.attachId = null;
					}
					data.parentId = parseInt(data.parentId, 0);
					categoryAdd(data).then(result => {
						hideSpin();
						if (result.status) {
							message.success(result.message);
							hashHistory.goBack();
						} else {
							message.error(result.message);
						}
					})
				} else {
					if (this.state.fileList[0] != null && this.state.fileList[0].response) {
						data.attachId = this.state.fileList[0].response.data.id;
					} else {
						data.attachId = null;
					}
					data.parentId = 0;
					categoryAdd(data).then(result => {
						hideSpin();
						if (result.status) {
							message.success(result.message);
							hashHistory.goBack();
						} else {
							message.error(result.message);
						}
					})
				}


			}

		})

	}


	render() {
		const {opts, detail, fileList} = this.state;
		const {getFieldDecorator} = this.props.form;
		const abbProps = {
			action: `${config.server}/api/v1/dms/commonAttachUpload/mongoUpload`,
			listType: 'picture',
			fileList: [...fileList], //受控模式不使用defaultFileList初始化，改用fileList
			className: 'upload-img-only',
			onChange: (info) => {
				let fileList = info.fileList;
				fileList = fileList.slice(-1); //控制上传数量
				fileList = fileList.map((file) => {
					if (file.response) {//上传成功后提取文件id 和 URL
						file.url = `${config.server}${file.response.data.filePath.split('?')[0]}?id=${file.response.data.id}`;
						file.id = file.response.data.id;
					}
					return file;
				});
				fileList = fileList.filter((file) => {
					if (file.response) {
						return file.response.status; //当上传接口返回成功时才更新fileList
					}
					return true;
				});

				this.setState({fileList}); //在该处理方法的结束位置必须执行此行代码，这是用来解决onChange只调用一次的问题
			}
		};

		return <div className='dms-body'>
			<DmsTab options={opts} defaultKey={0}>
				<Button onClick={this.cancelHandle.bind(this)}>取消</Button>
				<Button type='primary' onClick={this.submitHandle.bind(this)}>保存</Button>
			</DmsTab>

			<div className="dms-table-box" style={{backgroundColor: "#fff"}}>

				<div className="upload_add_pro" style={{marginBottom: '12px'}}>
					<Upload {...abbProps}>
						<Button type="primary"
								style={{background: '#108ee9', color: '#fff', borderColor: '#108ee9'}}>
							选择图片文件
						</Button>
						<span className="hint">建议图片大小 : 118x95px <span
							style={{color: '#d61418'}}>(只能保存一张图片)</span></span>
					</Upload>
				</div>

				<Form layout="horizontal">
					<Row gutter={16}>
						<Col className="gutter-row" span={12}>
							<FormItem label="分类名称" hasFeedback>
								{getFieldDecorator('name', {
									initialValue: (detail !== null && detail.name) ? detail.name : '',
									rules: [
										{
											required: true,
											message: '请输入分类名称'
										}
									],
								})(<Input placeholder="请输入分类名称"/>)}
							</FormItem>
						</Col>
						<Col className="gutter-row" span={12}>
							<FormItem label="分类编码" hasFeedback>
								{getFieldDecorator('code', {
									initialValue: (detail !== null && detail.code) ? detail.code : '',
									rules: [
										{
											required: true,
											message: '请输入分类编码'
										},
										{
											validator: checkCode
										}
									],
								})(<Input disabled={!!this.id} placeholder="请输入分类编码"/>)}
							</FormItem>
						</Col>
					</Row>

					<Row>
						<FormItem label="上级分类">
							{getFieldDecorator('parentId', {
								initialValue: (detail !== null && detail.parentId) ? detail.parentId : ''
							})(<TreeSelect
								disabled={this.state.parentFlag}
								showSearch={true}
								dropdownStyle={{maxHeight: '450px', overflow: 'auto'}}
								style={{width: '100%'}}
								placeholder="请选择上级分类"
								allowClear
								treeDefaultExpandedKeys={(detail !== null && detail.parentId) ? [detail.parentId]: []}
								treeDefaultExpandAll={false}
								treeNodeFilterProp="label"
								treeData={this.state.tree}
							/>)}
						</FormItem>
					</Row>

					<Row>
						<FormItem label="类别描述">
							{getFieldDecorator('description', {
								initialValue: (detail !== null && detail.description) ? detail.description : ''
							})(<TextArea rows={4}/>)}
						</FormItem>
					</Row>

					<Row gutter={16}>
						<Col className="gutter-row" span={12}>
							<FormItem label="有效性">
								{getFieldDecorator('active', {
									initialValue: detail.active,
									rules: [
										{
											required: true,
											message: '请选择是否有效'
										},
									]
								})(<Select>
									<Option value='Y'>有效</Option>
									<Option value='N'>无效</Option>
								</Select>)}
							</FormItem>
						</Col>
					</Row>

				</Form>
			</div>
		</div>
	}
}
export default Form.create()(Categoryadd)



// WEBPACK FOOTER //
// ./src/routes/category/add.js